export default __webpack_public_path__ + "static/media/bb1.4f662ca6.png";